import { createContext, useContext } from "react";

type SizeContextProps = {
  name: string;
  onClick: (value: string) => void;
  longestLabel?: string;
  brand: string;
  hasDiorPromosEnabled: boolean;
};

const SizeContext = createContext<SizeContextProps | null>(null);

export const { Provider: SizeContextProvider } = SizeContext;

export const useSizeContext = () => {
  const context = useContext(SizeContext);
  if (!context) {
    throw new Error("Please wrap the component under SizeContextProvider");
  }
  return context;
};
